const urlLang = window.location.pathname.includes('/es')
  ? 'es'
  : window.location.pathname.includes('/en')
  ? 'en'
  : localStorage.getItem('i18nextLng') || 'en';
const initialState = {
  actionResult: {},
  agency: {
    agencyIds: [],
    agencies: {},
    appIds: [],
    apps: {},
    linkUserKeys: [],
    links: {},
  },
  alert: {},
  app: {},
  auth: {
    isPermittedToAuthenticateViaIdology: true,
  },
  content: {},
  createAccount: {},
  forgotPassword: {},
  forgotUsername: {},
  reverify: {},
  language: {
    selected: urlLang,
    options: [
      {
        label: 'English',
        value: 'eng',
        code: 'en',
      },
      {
        label: 'Español',
        value: 'esp',
        code: 'es',
      },
    ],
  },
  login: {},
  mobileNav: {},
  modal: {},
  navbar: {},
  OTP: {},
  user: {
    todo: [],
  },
  session: {
    dmvFlowActive: false,
    timeoutModal: {
      name: 'SessionWarningModal',
      duration: 2,
      warning: {},
    },
  },
  onboarding: {},
  bnlr: {},
  dps: {
    selected: '',
  },
  tdlr: {
    selected: '',
  },
  dmv: {
    selected: '',
  },
  tpwd: {
    selected: '',
  },
   txhhs: {
    selected: '',
  },
  txrc: {
    selected: '',
  },
  cybersecurity: {},
  payment: { applicationId: 'MGMW' },
  appHistory: {
    activity: 6,
    transactions: 6,
  },
  messageBanner: {
    messages: [],
    dismissed: [],
  },
};

export default initialState;
